// source: event.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var job_pb = require('./job_pb.js');
goog.object.extend(proto, job_pb);
var comments_pb = require('./comments_pb.js');
goog.object.extend(proto, comments_pb);
goog.exportSymbol('proto.cloud.ProjectEvent', null, global);
goog.exportSymbol('proto.cloud.ProjectEventType', null, global);
goog.exportSymbol('proto.cloud.UserEvent', null, global);
goog.exportSymbol('proto.cloud.UserEventType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ProjectEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.ProjectEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ProjectEvent.displayName = 'proto.cloud.ProjectEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UserEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserEvent.displayName = 'proto.cloud.UserEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ProjectEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ProjectEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ProjectEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    jobInfo: (f = msg.getJobInfo()) && job_pb.JobInfoIngest.toObject(includeInstance, f),
    comment: (f = msg.getComment()) && comments_pb.CommentQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ProjectEvent}
 */
proto.cloud.ProjectEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ProjectEvent;
  return proto.cloud.ProjectEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ProjectEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ProjectEvent}
 */
proto.cloud.ProjectEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.ProjectEventType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new job_pb.JobInfoIngest;
      reader.readMessage(value,job_pb.JobInfoIngest.deserializeBinaryFromReader);
      msg.setJobInfo(value);
      break;
    case 4:
      var value = new comments_pb.CommentQuery;
      reader.readMessage(value,comments_pb.CommentQuery.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ProjectEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ProjectEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ProjectEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ProjectEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getJobInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      job_pb.JobInfoIngest.serializeBinaryToWriter
    );
  }
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      comments_pb.CommentQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.cloud.ProjectEvent.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.ProjectEvent} returns this
 */
proto.cloud.ProjectEvent.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProjectEventType type = 2;
 * @return {!proto.cloud.ProjectEventType}
 */
proto.cloud.ProjectEvent.prototype.getType = function() {
  return /** @type {!proto.cloud.ProjectEventType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.ProjectEventType} value
 * @return {!proto.cloud.ProjectEvent} returns this
 */
proto.cloud.ProjectEvent.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional JobInfoIngest job_info = 3;
 * @return {?proto.cloud.JobInfoIngest}
 */
proto.cloud.ProjectEvent.prototype.getJobInfo = function() {
  return /** @type{?proto.cloud.JobInfoIngest} */ (
    jspb.Message.getWrapperField(this, job_pb.JobInfoIngest, 3));
};


/**
 * @param {?proto.cloud.JobInfoIngest|undefined} value
 * @return {!proto.cloud.ProjectEvent} returns this
*/
proto.cloud.ProjectEvent.prototype.setJobInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ProjectEvent} returns this
 */
proto.cloud.ProjectEvent.prototype.clearJobInfo = function() {
  return this.setJobInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ProjectEvent.prototype.hasJobInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CommentQuery comment = 4;
 * @return {?proto.cloud.CommentQuery}
 */
proto.cloud.ProjectEvent.prototype.getComment = function() {
  return /** @type{?proto.cloud.CommentQuery} */ (
    jspb.Message.getWrapperField(this, comments_pb.CommentQuery, 4));
};


/**
 * @param {?proto.cloud.CommentQuery|undefined} value
 * @return {!proto.cloud.ProjectEvent} returns this
*/
proto.cloud.ProjectEvent.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ProjectEvent} returns this
 */
proto.cloud.ProjectEvent.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ProjectEvent.prototype.hasComment = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserEvent}
 */
proto.cloud.UserEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserEvent;
  return proto.cloud.UserEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserEvent}
 */
proto.cloud.UserEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.UserEventType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.cloud.UserEvent.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserEvent} returns this
 */
proto.cloud.UserEvent.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserEventType type = 2;
 * @return {!proto.cloud.UserEventType}
 */
proto.cloud.UserEvent.prototype.getType = function() {
  return /** @type {!proto.cloud.UserEventType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.UserEventType} value
 * @return {!proto.cloud.UserEvent} returns this
 */
proto.cloud.UserEvent.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.cloud.ProjectEventType = {
  PROJECT_EVENT_NONE: 0,
  PROJECT_EVENT_JOB_INIT: 1,
  PROJECT_EVENT_JOB_UPDATE: 2,
  PROJECT_EVENT_JOB_FINAL: 3,
  PROJECT_EVENT_COMMENT_ADDED: 10
};

/**
 * @enum {number}
 */
proto.cloud.UserEventType = {
  USER_EVENT_NONE: 0
};

goog.object.extend(exports, proto.cloud);
